import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authApi } from '../api/client';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await authApi.forgotPassword({ email });
    } catch (err) {
      // Intentionally silent — the API is enumeration-safe and always
      // returns ok. We only catch network-level failures here, and we
      // still surface the same neutral message so we don't reveal state.
    } finally {
      setSubmitted(true);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="forgot-password-page">
      <div className="w-full max-w-sm">
        <h1 className="font-serif text-3xl font-light text-center mb-3">Wachtwoord vergeten</h1>
        <p className="text-sm text-muted-foreground text-center mb-8">
          Vul uw e-mailadres in en we sturen u een link om uw wachtwoord opnieuw in te stellen.
        </p>

        {submitted ? (
          <div className="space-y-4" data-testid="forgot-password-success">
            <div className="text-sm bg-primary/5 border border-primary/20 text-primary px-4 py-3 rounded-lg">
              Als dit e-mailadres bestaat, ontvang je een link om je wachtwoord te resetten.
            </div>
            <Link
              to="/login"
              data-testid="forgot-password-back-to-login"
              className="block text-center text-sm text-primary font-medium hover:underline"
            >
              Terug naar inloggen
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Email</label>
              <input
                data-testid="forgot-password-email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full px-4 py-2.5 rounded-lg border border-input bg-card text-sm focus:outline-none focus:ring-2 focus:ring-ring"
              />
            </div>
            <button
              data-testid="forgot-password-submit"
              type="submit" disabled={loading}
              className="w-full bg-primary text-primary-foreground rounded-full py-3 font-semibold hover:bg-primary/90 transition-all active:scale-95 disabled:opacity-50"
            >
              {loading ? 'Bezig...' : 'Stuur resetlink'}
            </button>
            <p className="text-center text-sm text-muted-foreground">
              <Link
                to="/login"
                data-testid="forgot-password-cancel-link"
                className="text-primary font-medium hover:underline"
              >
                Terug naar inloggen
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
